<div class="ag-checkbox">
  <eds-checkbox
    [id]="uniqueInputId"
    [hideLabel]="true"
    [stopEventTracking]="true"
    [checked]="isSelected"
    (checkedChange)="onSelectAllClick($event)"
    [required]="false"
    [tabIndex]="0"
    [hasFocusShadow]="true"
    [name]="params?.checkboxLabel"
    [isKeyboardInteractive]="true"
  ></eds-checkbox>
  <label [for]="uniqueInputId" class="sr-only">
    {{ params?.checkboxLabel }}</label
  >
</div>
